module.exports = __webpack_public_path__ + "img/Madeline-Haines-2.ae484ff5.jpg";